import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const getLanguageLabel = (code: string) => {
    switch (code) {
        case "en":
            return "English";
        case "es":
            return "Español";
        case "it":
            return "Italiano";
        default:
            return "English";
    }
};

export const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const currentLanguage = getLanguageLabel(i18n.language);

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button className="flex items-center text-gray-700 hover:text-primary">
                    <Globe size={20} className="mr-1" />
                    <span>{currentLanguage}</span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <DropdownMenuItem onClick={() => changeLanguage("en")}>
                    English
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => changeLanguage("es")}>
                    Español
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => changeLanguage("it")}>
                    Italiano
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
